export default {
  printf() {
    return 'miniprogram-custom-component api demo'
  }
}
